// extracted by mini-css-extract-plugin
export default {"component":"Testimonials_component__ujzVm","main":"Testimonials_main__Kr7G1"};